<div class="card-container-shadow padding-md" [class.card-container-active]="active" [class.no-shadow]="active" [ngStyle]="cardStyles">
  <div class="info">
    <div class="mr-xs">
      <app-avatar-user [image]="imageProfile" [name]="name" [lastname]="lastName" [width]="45" [fontSize]="'15px'"></app-avatar-user>
    </div>
    <div class="name">
      <p class="text-regular-14 truncate">{{ name }}</p>
      <p *ngIf="email" class="text-info truncate">{{ email }}</p>
    </div>
  </div>
  <div class="folio mt-xs d-flex justify-content-between" *ngIf="folio">
    <p class="text-subtitle">{{ folio }}</p>
    <p class="text-link" (click)="onEmitViewProfile()">Ver perfil</p>
  </div>
</div>
